import React from 'react';
import { graphql } from 'react-relay';
import { useFragment } from 'react-relay/hooks';
import A from 'components/atoms/A/A';
import Card from 'components/atoms/Card/Card';
import Image from 'components/atoms/Image/Image';
import classes from './BlogPostItem.qmee.module.scss';
import { BlogPostItem_item$key } from './__generated__/BlogPostItem_item.graphql';

export interface Props {
  postRef: BlogPostItem_item$key;
}

const fragmentSpec = graphql`
  fragment BlogPostItem_item on BlogPost {
    title
    imageUrl
    excerpt
    date
    slug
  }
`;

const BlogPostItem: React.FC<Props> = ({ postRef }) => {
  const post = useFragment(fragmentSpec, postRef);

  return (
    <A href={`/blog/${post.slug}`} className={classes.link}>
      <Card isLink className={classes.root}>
        {post.imageUrl && (
          <Image
            className={classes.itemImage}
            loading="lazy"
            src={post.imageUrl}
            alt=""
            width={388}
            height={217}
          />
        )}
        <div className={classes.content}>
          <h3 className={classes.title}>{post.title}</h3>
          {post.date && (
            <span className={classes.date}>
              {new Date(post.date).toLocaleDateString('en-US', {
                month: 'long',
                day: 'numeric',
                year: 'numeric',
              })}
            </span>
          )}
        </div>
      </Card>
    </A>
  );
};

export default BlogPostItem;
